import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';
import { LOGIN_PAGE_BG_IMG_URl } from '@utils/data';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: theme.palette.whitePepper.main,
  },

  leftSectionContainer: {
    flex: 1,
    flexShrink: 0,
    position: 'relative',
    width: '100%',
    flexBasis: '50%',
    backgroundImage: `url(${LOGIN_PAGE_BG_IMG_URl})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  rightSectionContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  headerContainer: {
    width: '100%',
    padding: '20px 25px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  wrapper: {
    maxWidth: '500px',
    padding: '10px 25px 50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,

    [theme.breakpoints.up('md')]: {
      maxWidth: 'none',
      padding: '60px 25px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '740px',
      padding: '60px 50px',
    },
    [theme.breakpoints.down('md')]: {
      flexGrow: 1,
    },
  },

  upperWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
  },

  loginTitle: {
    marginBottom: '30px',
  },

  sendLinkInstruction: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '50px',
  },

  formContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '50px 0',

    //marginTop: '115px',
    [theme.breakpoints.up('md')]: {
      //marginTop: '190px',
      maxWidth: '400px',
      padding: '0',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '500px',
      padding: '0',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '540px',
    },
  },

  formItem: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: '25px',
      marginBottom: '30px',
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: '75px',
    },
    [theme.breakpoints.up('xl')]: {
      columnGap: '100px',
    },
  },

  input: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '300px',
      marginBottom: '0px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '330px',
    },
  },

  emailError: {
    zIndex: 10,
    position: 'absolute',
    top: '65px',
  },

  instructions: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      rowGap: '15px',
    },
  },

  registeredSubscription: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '5px',
    marginTop: '35px',

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  loginBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '45px',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  goToHomePageBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '45px',
  },

  desktopLoginBtn: {
    width: '350px !important',

    [theme.breakpoints.up('lg')]: {
      width: '400px !important',
    },
    [theme.breakpoints.up('xl')]: {
      width: '425px !important',
    },
  },

  loginBtn: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});
